import {UTMParameters} from "../../../shared/@types/utmResources.ts";

const utmParameters = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export const saveUTMParameters = (): void => {
    const urlParams = new URLSearchParams(window.location.search);

    utmParameters.forEach(param => {
        const value = urlParams.get(param);
        if (value) {
            sessionStorage.setItem(param, value);
        }
    });
}

export const getUTMParameters = (): UTMParameters => {
    const storedUTMParams: UTMParameters = {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
    };

    utmParameters.forEach(param => {
        const value = sessionStorage.getItem(param);
        if (value) {
            storedUTMParams[param as keyof UTMParameters] = value;
        }
    });

    return storedUTMParams;
}
